export default __webpack_public_path__ + "static/media/food-logo.1215ecec.jpg";